export default __webpack_public_path__ + "static/media/V.4a7ed079.svg";